import {Component, OnInit, ViewChild, Output, EventEmitter, ViewChildren, QueryList, ChangeDetectorRef} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import * as _ from 'lodash';
import {FileUploader, FileItem} from "ng2-file-upload";
import { Http} from "@angular/http";
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {BatchPaymentsService} from '../../../models/batch-payments/batch-payments.service';
import {BatchPaymentClientsModel} from '../../../models/batch-payments/batch-payments.model';
import {ClientsService} from '../../../models/clients/clients.service';
import {DebtsService} from "../../../models/debts/debts.service";
import {UsersService} from "../../../models/users/users.service";
import { ApplicationUser } from './../../../services/ApplicationUser';
import {AccountStatusesModel} from "../../../models/debts/debts.model";
import {ProcessingItemComponent} from "./item/processing-item.component";
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'processing',
    templateUrl: 'processing.template.html',
    styleUrls: ['processing.css']
})
export class ProcessingComponent implements OnInit {

    @ViewChild('uploadedFile')
    uploadedFile: any;

    @ViewChildren(ProcessingItemComponent) processingItems: QueryList <ProcessingItemComponent>;
    public children = [];

    public uploader:FileUploader;

    public tabs;
    public clients = <BatchPaymentClientsModel[]> [];
    public processingAccountStatus = null;
    public processingAccountStatuses = <AccountStatusesModel[]> [];

    private _items = new Subject<any>();

    public onChange = this._items.asObservable();
    
    constructor(
        private router: Router,
        private batchPaymentsService: BatchPaymentsService,
        public clientsService: ClientsService,
        private debtsService: DebtsService,
        public Users: UsersService,
        public http: Http,
        public toasterService: ToasterService,
        public debtService: DebtsService,
        public cdr: ChangeDetectorRef,

    ) {
        this.Users = new UsersService(this.http);
    }


    ngOnInit() {

        this.debtService.getAccountStatuses({funded: this.debtService.accountStatusTypes.FUNDED})
            .subscribe((res) => {
                this.processingAccountStatuses = res.data;
            });

        this.batchPaymentsService.getList()
            .subscribe((res) => {
                this.clients = res.data;
                this.changingStatusForClientId = 0;
            })

        let user = ApplicationUser.getInstance();

        this.uploader = new FileUploader({
            url: '/api/v1/transactions/import',
            headers: [{name: 'Authorization',value: user.getAccessToken()}],
            queueLimit: 2,
            isHTML5: true,
            itemAlias: 'importFile',
            additionalParameter: {
                opener: []
            }
        });

        this.uploader.onSuccessItem = (item: FileItem, response: string) => {

            let resData = JSON.parse(response);

            if(!resData.data.result.error) {

                this.updateItems(resData.data.result.rows);

                this.toasterService.pop('success', 'Success', resData.data.result.success + ' transactions imported, ' +
                    resData.data.result.ignore + ' transactions ignored');
            } else {
                this.toasterService.pop('error', 'Error', 'Import of ' + resData.data.result.error + ' items failed');
            }


            this.clearUploader();

        };

        this.uploader.onErrorItem = (item, response) => {
            let resp = JSON.parse(response);
            this.toasterService.pop('error', 'Error', resp.code + ': ' + resp.message);

            this.clearUploader();
        };

    }

    private updateItems(batch) {
        this._items.next(batch);
    }

    public refreshTable(status) {
        this.batchPaymentsService.getList({debt_status: status})
            .subscribe((res) => {
                this.clients = res.data;
                this.changingStatusForClientId = 0;
            })
    }

    clearUploader() {
        this.uploadedFile.nativeElement.value = '';
        this.uploader.clearQueue();
    }

    selectedClientId: any = 0;

    toggleClient(id: any)
    {
        if (this.selectedClientId == id) this.selectedClientId = 0;
        else this.selectedClientId = id;
    }

    isSelected(id: any): any
    {
        return this.selectedClientId == id;
    }

    changingStatusForClientId: any = 0;

    isShowChangeStatus(client: any): any
    {
        return this.changingStatusForClientId == client.id;
    }

    showChangeStatus(client: any)
    {
        this.changingStatusForClientId = client.id;
        client.debtStatuses.newStatusId = client.debtStatuses.id; 
    }

    saveNewDebtStatus(client: any)
    {
        if (! client.debtStatuses.newStatusId) {
            client.debtStatuses._in_process = null;
            if (this.changingStatusForClientId == client.id) this.changingStatusForClientId = 0;
            return;
        }
        client.debtStatuses._in_process = {};
        let _in_proc: any = client.debtStatuses._in_process;

        this.batchPaymentsService.changeFundedDebtStatus(client.id, client.debtStatuses.newStatusId)
            .subscribe(r => {
                if (_in_proc !== client.debtStatuses._in_process) return;
                client.debtStatuses = r.data;
                if (this.changingStatusForClientId == client.id) this.changingStatusForClientId = 0;
            });
    }

    statusChangingInProcess(client: any): any
    {
        return client.debtStatuses._in_process ? true : false;
    }

    closeCangingEdit(event: any)
    {
        try {
            let elem: any = event.target;
            do {
                if (elem.classList.contains('change-target-elem')) return;
                elem = elem.parentNode;
            } while (elem && elem.classList);
        } catch (e) {}

        this.changingStatusForClientId = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/accounting/processing/processing.component.ts